module.exports = __webpack_public_path__ + "media/homepage/randi_@2x-519f952c.png";